module.exports = __webpack_public_path__ + "img/tcm-university-info.0321961f.png";